import { render, staticRenderFns } from "./Parcelles.vue?vue&type=template&id=a055aec2&"
import script from "./Parcelles.vue?vue&type=script&lang=js&"
export * from "./Parcelles.vue?vue&type=script&lang=js&"
import style0 from "./Parcelles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports